import * as config from '../config';
import { getCookie } from '../../components/common/cookie';
import { debug } from '../../utils/env';
import { deepLoop } from '../hooks'
import { useRequest } from 'ahooks';

export function getClubApiRoot() {
  const origin = document.location.origin;
  if (origin === config.URL_prod) {
    return config.URL_CLUB_API_prod;
  } else {
    return config.URL_CLUB_API_qa;
  }
}
export const CLUB_API_ROOT = getClubApiRoot();

const fetchWrapper = async (
  method,
  endpoint,
  request = {},
  responseType = 'json'
) => {
  const options = {
    method,
    headers: {
      'content-type': 'application/json; charset=utf-8',
    },
  };
  const padiWxId = getCookie('padiWxId')
  let url = `${CLUB_API_ROOT}${endpoint}`;
  if(padiWxId) request.token = padiWxId
  const newRequest = deepLoop(request)
  if (method === 'POST') {
    options.body = JSON.stringify(newRequest);
  } else if ((method === 'GET') && endpoint.indexOf('getWxJsSign') < 0) {
    const queryObj = new URLSearchParams(newRequest);
    url += `?${queryObj.toString()}`;
  }
  debug('Fetch url: ', url);
  debug('Fetch options: ', options);
  const result = await fetch(url, options).then((response) => {
    debug('Reponse type: ', response.type);
    return response[responseType]();
  }).catch(err => {
    debug('Fetch error: ', err)
    throw err
    // return err
  });
  debug('Fetch Result: ', result);
  if (result.control.status !== 200) throw result.control;
  return result.data;
};

export const useRequestCommon = (service, options = {}) => {
  return useRequest(service, {
    manual: true,
    ...options,
    // onSuccess: (data) => {
    //   console.log(data,'!!!!!!!!')
    // }
  });
};

export const authedGetService = (url, params, responseType = 'json') =>
  fetchWrapper('GET', url, params, responseType);
export const authedPostService = (url, params, responseType = 'json') =>
  fetchWrapper('POST', url, params, responseType);

  export const useHomeBanner = (options) =>
  useRequestCommon(
    () => authedGetService(config.homeBanner, {}),{
      manual: false,
      ...options
    }
  );